<template>
  <div class="mt-2">
      <table>
          <tr>
              <td class="table-label">送信日</td>
              <td >{{ formatDate(message.sent_date)}}</td>
              <td class="table-label">差出人名</td>
              <td>{{ message.sender }}</td>
          </tr>
          <tr>
              <td class="table-label">スカウト求人</td>
              <td colspan="4" class="detail" >{{ message.job_title }}</td>
          </tr>
          <tr>
              <td class="table-label">回答日</td>
              <td>{{ formatDate(message.replied_date) }}</td>
              <td class="table-label">回答内容</td>
              <td>{{ message.user_response }}</td>
          </tr>
          <tr>
              <td class="table-label">任意コメント</td>
              <td colspan="4" class="detail">{{ userQuestion}}</td>
          </tr>
      </table>
    </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'MessageDetailTable',
  props: ["message"],
  methods:{
      formatDate(date){
          return date ? moment(date).format('YYYY/MM/DD') : '';
      },
  },
  computed: {
    userQuestion() {
      if(this.message.contact_type === 'その他通知') {
        return "-"
      } else {
        return this.message.user_question;
      }
    }
  }
}

</script>

<style scoped>
table{
  width: 100%
}
.table-label{
  /* width: 85px !important; */
  text-align: center;
  background-color: #D9D9D9 !important;
}

.detail{
  text-align: left !important;
  margin-left: 5px;
  word-wrap: break-word;
  max-width: 200px;
}
td{
  border: 2px solid #E6E6E6;
  background-color: #fff;
  text-align: center;
  padding: 5px;
  font-size: 14px;
  width:300px;
  background-color: #fff;
  color: #3c3c3c;
}
</style>